// @flow
import React from 'react';
import classNames from 'classnames/bind';
import { IconOk, IconClose } from '../../_Icons';
import styles from './BoolItem.scss';


const cx = classNames.bind(styles);

type IconProps = {
  checked: boolean,
  className: string,
}
const Icon = ({ checked, className }: IconProps) => (checked
  ? <IconOk className={className} />
  : <IconClose className={className} />
);

type Props = {
  label?: any,
  checked?: boolean,
  className?: string,
  empty?: boolean,
  children?: any,
}
const BoolItem = ({ label, checked, className, empty, children, ...other }: Props) =>
  <div {...other} className={cx({ root: true }, className)}>
    {empty
      ? (!children && <div className={styles.empty} />)
      : <Icon className={cx({ icon: true, checked })} checked={!!checked} />
    }
    {label && <span className={styles.label}>{label}</span>}
    {children}
  </div>;

export default BoolItem;
